"use client";

import { legacyIconCls } from "@faire/web/slate/utils/tracking";
import React from "react";

import { createSVGIcon } from "./util";

/**
 * @trackcomponent
 * @optimized using svgo:^3.0.2
 */
export const WomenOwned = createSVGIcon(
  <>
    <path
      d="M16.244 8.607v-.069a5.538 5.538 0 1 0-11.077 0V21h11.077z"
      fill="#E8E1D2"
    />
    <path
      d="M18.67 10.575v7.274H9.465v-7.373h-.5.5a4.603 4.603 0 1 1 9.206.1Z"
      stroke="#312921"
    />
  </>,
  "Women owned",
  {
    viewBox: "0 0 24 24",
    titleAccess: "Women owned",
    fill: "none",
    className: legacyIconCls(),
  }
);
